import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { Typography } from 'components/Typography/Typography'
import { IconRight } from 'components/Icons/IconRight'
import { Stylable } from 'utils/types'

interface Breadcrumb {
  label: string
  path: string
}

interface BreadcrumbsProps extends Stylable {
  items: Breadcrumb[]
}

const BreadcrumbsContainer = styled.nav`
  display: flex;
  align-items: center;
  font-size: ${p => p.theme.typography.size.Description}px;
  max-width: 1200px;
  margin: 16px auto;
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    // padding: 0 20px;
  }
`

const BreadcrumbItem = styled.div`
  display: flex;
  align-items: center;
  & > svg {
    margin: 0 16px;
  }
`

const BreadcrumbLink = styled(Link)`
  color: ${p => p.theme.colors.text.secondary};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

const Breadcrumbs = ({ items, style }: BreadcrumbsProps) => {
  return (
    <BreadcrumbsContainer style={style}>
      {items.map((item, index) => (
        <BreadcrumbItem key={index}>
          {index < items.length - 1 ? (
            <>
              <BreadcrumbLink to={item.path}>{item.label}</BreadcrumbLink>
              <IconRight />
            </>
          ) : (
            <Typography variant="description" fontWeight="semiBold">
              {item.label}
            </Typography>
          )}
        </BreadcrumbItem>
      ))}
    </BreadcrumbsContainer>
  )
}

export default Breadcrumbs
